import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import Chip, { CHIP_COLORS } from "../../../../components/chip/chip";
import { RMA_STATUS_TRANSLATION_KEY } from "../../../../services/api/rma-list-service";

interface IProps {
    statusKey: RMA_STATUS_TRANSLATION_KEY;
}

const RMAStatusChipColorMap: { [key: string]: CHIP_COLORS } = {
    'RMA_STATUS_PENDING_MANAGER_APPROVAL': CHIP_COLORS.PENDING,
    'RMA_STATUS_PENDING': CHIP_COLORS.PENDING,
    'RMA_STATUS_DONE': CHIP_COLORS.DONE,
    'RMA_STATUS_APPROVED': CHIP_COLORS.APPROVED,
    'RMA_STATUS_SHIPMENT_RECEIVED': CHIP_COLORS.SHIPMENT_RECEIVED,
    'RMA_STATUS_REJECTED': CHIP_COLORS.REJECTED,
    'RMA_STATUS_CANCELLED': CHIP_COLORS.CANCELLED,
}

const RmaStatusChip: React.FC<IProps> = ({ statusKey }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-returns-page';
    return (
        <Chip label={getTranslation(statusKey, scope)} color={RMAStatusChipColorMap[statusKey] ?? CHIP_COLORS.DEFAULT} />
    )
};

export default RmaStatusChip;
